import { render, staticRenderFns } from "./jobinformationList.vue?vue&type=template&id=4b80a703&"
import script from "./jobinformationList.vue?vue&type=script&lang=js&"
export * from "./jobinformationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports